module.exports = __webpack_public_path__ + "static/media/betterModal.c1b3f8a8.jpg";